import { Styled } from './index.styles';
import { CheckCircle, Error, Warning, Info, ErrorOutline } from '@mui/icons-material';

interface PropsModel {
    state?: 'success' | 'error' | 'warning' | 'info' | 'default' | 'error-outline';
    text: string | React.ReactNode;
    size?: 'large' | 'middle' | 'small';
    showIcon?: boolean;
    icon?: any;
    className?: string;
    desc?: string;
    wrap?: boolean;
    fullWidth?: boolean;
}
const MiniAlert = (props: PropsModel) => {
    const {
        state = 'default',
        size = 'middle',
        fullWidth = false,
        showIcon = false,
        text,
        icon,
        className,
        desc,
        wrap = false,
    } = props;

    const iconHtml = (prop: any) => {
        switch (prop) {
            case 'success':
                return <CheckCircle />;
            case 'error':
                return <Error />;
            case 'error-outline':
                return <ErrorOutline />;
            case 'warning':
                return <Warning />;
            case 'info':
                return <Info />;
            default:
                return '';
        }
    };

    return (
        <Styled>
            <div
                className={`mini-alert state-${state} size-${size} fullWidth-${fullWidth} ${
                    wrap ? 'wrap' : 'no-wrap'
                } ${className}`}
            >
                {showIcon && <div className="icon">{!icon ? iconHtml(state) : icon}</div>}
                <div className="text-area">
                    <div className="text">{text}</div>
                    <div className="text-desc">{desc}</div>
                </div>
            </div>
        </Styled>
    );
};

export default MiniAlert;
